import styled from '@emotion/styled';
import { H2 } from 'ds/components/typography';

export const AvatarWrapper = styled(H2.withComponent('div'))<{ size: number; imageVisible?: boolean }>`
  ${({ size, imageVisible, theme }) => `
    width: ${size}px;
    height: ${size}px;
    border-radius: ${theme.borderRadius.round};
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${theme.colors.neutrals.white};
    background-color: ${imageVisible ? 'unset' : theme.colors.brand.dark};
    border: 1px solid ${imageVisible ? theme.colors.neutrals.grey8 : theme.colors.brand.dark};
    font-weight: bold;
    overflow: hidden;
    text-transform: uppercase;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }

  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 48px;
    height: 48px;
  `}
`;
